var map = {
	"./all-example.json": "./src/assets/ressources/jsonfiles/all-example.json",
	"./booking-searchfields.json": "./src/assets/ressources/jsonfiles/booking-searchfields.json",
	"./etataquai-searchfields.json": "./src/assets/ressources/jsonfiles/etataquai-searchfields.json",
	"./freight-audit-searchfields.json": "./src/assets/ressources/jsonfiles/freight-audit-searchfields.json",
	"./pricing-searchfields.json": "./src/assets/ressources/jsonfiles/pricing-searchfields.json",
	"./quality-management-search.json": "./src/assets/ressources/jsonfiles/quality-management-search.json",
	"./tracing-searchfields.json": "./src/assets/ressources/jsonfiles/tracing-searchfields.json"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/ressources/jsonfiles recursive ^\\.\\/.*\\.json$";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ressources/jsonfiles ^\.\/.*\.json$
// module id = ./src/assets/ressources/jsonfiles recursive ^\.\/.*\.json$
// module chunks = main